import { MainService } from 'src/app/Services/service.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from "@angular/material";
import isMobile from "is-mobile";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-enter-dialog",
  templateUrl: "./enter-dialog.component.html",
  styleUrls: ["./enter-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class EnterDialogComponent implements OnInit {
  subscription: Subscription 
  loaderBody: HTMLElement
  logo: HTMLImageElement = document.createElement('img');
  public isMobile:boolean = false;
  constructor(public dialogRef: MatDialogRef<EnterDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private router: Router, public service: MainService) {
    
    this.dialogRef.addPanelClass("enter-dialog-backdrop");

    if (isMobile() || environment.name == "CORDOVA")
    {
      this.isMobile = true;
    }
    this.subscription = this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            document.body.classList.remove("js-loader-active", "blacked");
            if(this.loaderBody) this.loaderBody.remove();
            this.subscription.unsubscribe()
          }
    });
  }

  ngAfterViewInit(){
    this.logo.addEventListener('load', (event) => {
      this.service.disclaimerIsReady = true;
    });
  }

  ngOnInit() {
    document.body.classList.add("js-loader-active");

    if(!this.isMobile){
      this.logo.src = 'assets/img/disclaimer_bg.jpg';
    }else{
      this.logo.src = 'assets/img/disclaimer_mobile.png';
    }
    
  }

  onOver18() {
    //document.body.classList.add("js-loader-active", "blacked");
    this.service.Over18Years = true;
    if(!this.service.aplicationIsReady) this.loaderBody.classList.remove("hidden");
    this.dialogRef.close(true);
  }
}
